<template>
  <v-navigation-drawer
    :mini-variant.sync="isMini"
    permanent
    color="dark"
    class="app-aside-nav"
    width="237"
    mini-variant-width="75"
    :class="!!fullHeight ? 'full-height' : ''"
  >
    <v-list dense nav class="nav-v-list">
      <div v-for="item in getNavItems" :key="item.title">
        <component :is="navComponent(item)" :item="item" />
      </div>
    </v-list>

    <div class="nav-separator" />
    <template v-slot:append>
      <div class="footer-logo" />
    </template>
  </v-navigation-drawer>
</template>

<script>
import Vue from "vue";
import { $eventHub } from "@/components";
import Storage from "@/services/storage";
import dashboardLinks from "./links/dashboard/index";
import callCenterLinks from "./links/call-center/index";
import oocLinks from "./links/ooc/index";
import { AppsConstraints } from "@/enums/apps.enum";

import LinkItem from "./link/index.vue";
import LinkGroup from "./group/index.vue";
import { StorageConstants } from "@/enums/storage.enum";
import { EventConstraints } from "@/enums/events.enum";
import "./styles.scss";

const AsideNav = Vue.extend({
  name: "AsideNav",

  components: { LinkItem, LinkGroup },

  beforeMount() {
    this.app = this.$route.meta?.app || AppsConstraints.DASHBOARD;
    $eventHub.$on(EventConstraints.TOGGLE_LEFT_SIDE_NAV, this.toggle);
    this.isMini = Storage.get(StorageConstants.LEFT_SIDE) || false;
  },

  beforeDestroy() {
    $eventHub.$off(EventConstraints.TOGGLE_LEFT_SIDE_NAV, this.toggle);
  },

  data() {
    return {
      isMini: false,
    };
  },

  props: {
    fullHeight: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    isMini: {
      immediate: true,
      handler(isMini) {
        this.isMini = Storage.get(StorageConstants.LEFT_SIDE) || false;
      },
    },
  },

  computed: {
    getNavItems() {
      switch (this.app) {
        case AppsConstraints.CALL_CENTER:
          return callCenterLinks;

        case AppsConstraints.OOC:
          return oocLinks;

        case AppsConstraints.DASHBOARD:
        default:
          return dashboardLinks;
      }
    },
  },

  methods: {
    toggle() {
      this.isMini = !this.isMini;
      Storage.set(StorageConstants.LEFT_SIDE, this.isMini);
      this.$forceUpdate();
    },

    navComponent(item) {
      const { children } = item;
      if (!children) {
        return LinkItem;
      }
      return LinkGroup;
    },
  },
});
export default AsideNav;
</script>
